module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "249",
      "src": "images/f0005-01.jpg",
      "width": "550"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "dedi"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("To")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("HAROLD C. BRYANT")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Superintendent Grand Canyon National Park")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("and")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("ERNIE APPLING")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Uncle Jim’s friend and a cowboy’s cowboy")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 60
// module chunks = 0